// Initialise the scrollify plugin

( function( $, window, document, undefined ) {

	let scrollifyController = ( () => {

		let isInitialised = false,
				minBreakpoint = 1023,
				currentIndex = 0,
				instance;

		function init() {
			if ( _shouldInit() ) {

				let $scrollSections = $('.js-scrolljacked-panel, .js-scrolljacked-interstitial');

				if ( $scrollSections.length && $.scrollify ) {

					$scrollSections.each( (id, section) => {
						let $section = $(section);

						$section.attr( 'data-section-name', $section.attr('id') );
						$section.removeAttr('id');
					} );

					instance = $.scrollify( {
						section: '.js-scrolljacked-panel',
						interstitialSection: '.js-scrolljacked-interstitial',
						target: '.js-main-scroll-container',
						disableSnapAfter: 3,
						standardScrollElements: ".js-header-inner.is-overflown, .j-message",
						afterRender: () => {
							createDots();

							currentIndex = $.scrollify.currentIndex();

							loadVideo( currentIndex );
							updateDots( currentIndex );

							// Adapter callback into event
							$(document).trigger( 'scrollify-after-render' );
						},
						before: ( index, elements ) => {
							loadVideo( index );
							updateDots( index );

							// Adapter callback into event
							$(document).trigger( 'scrollify-before-move', [ index, elements ] );
						},
						after: ( index, elements ) => {
							const delta = index - currentIndex;

							if ( index !== currentIndex ) {
								pauseVideo( currentIndex );
							} else {
								loadVideo( index );
							}

							currentIndex = index;

							updateDots( index );

							// Adapter callback into event
							$(document).trigger( 'scrollify-after-move', [ index, elements ] );
						}
					} );

				}

				$('body').addClass('scrollify-initialised');
				isInitialised = true;

			}
		}

		function _shouldInit() {
			return $('body').hasClass('home');
		}

		function destroy() {
			if ( isInitialised ) {

				$.scrollify.destroy();
				destroyDots();
				
				$('body').removeClass('scrollify-initialised');

				instance = null;
				isInitialised = false;

			}
		}

		function update() {
			if ( isInitialised ) {

				if ( windowWidth() <= minBreakpoint ) {
					// Initialised & under min breakpoint
					destroy();
					
					$('[data-video]').each( ( index, section ) => {
						section.videoController = null;
						$(section).find('video').remove();
					} );
				} else {
					// Initialised & over min breakpoint
					$.scrollify.update();
				}

			} else {

				if ( windowWidth() > minBreakpoint ) {
					// Not initialised & over min breakpoint
					init();
				}

			}
		}

		function loadVideo( index ) {
			let $element = $.scrollify.elements()[ index ],
					$videoWrapper = $element.find('[data-video]');

			if ( $videoWrapper.length ) {
				if ( !$videoWrapper.get(0).videoController ) {
					$videoWrapper.get(0).videoController = new VideoController( $videoWrapper );
				} else {
					$videoWrapper.get(0).videoController.play();
				}
			}
		}

		function pauseVideo( index ) {
			let $element = $.scrollify.elements()[ index ],
					$videoWrapper = $element.find('[data-video]');

			if ( $videoWrapper.length ) {
				$videoWrapper.get(0).videoController.rewind();
			}
		}

		function createDots() {
			let $panels = $('.js-scrolljacked-panel'),
					dots = '<ul class="scrolljacked-panels-dots js-scrollify-dots">';

			$panels.each( (index, panel) => {
				let $panel = $(panel),
						panelName = $panel.data('name');

				dots += '<li>';

				dots += `<button class="scrolljacked-panels-dots__button js-scrollify-dot" type="button" data-index="${index}" data-name="${panelName}" aria-labelledby="scrolljacked-dot-label-${index}">`;
				dots += `&nbsp;`;
				dots += '</button>';

				dots += `<span class="scrolljacked-panels-dots__tooltip" id="scrolljacked-dot-label-${index}" tabindex="-1">${panelName}</span>`;

				dots += '</li>';
			} );

			dots += '</ul>';

			$('.js-scrollify-container').append( $(dots) );

			$(document).on( 'click.scrollifyDot', '.js-scrollify-dot', (event) => {
				let $target = $(event.target);

				if ( !$target.is('.js-scrollify-dot') ) {
					$target = $target.closest('.js-scrollify-dot');
				}

				$.scrollify.move( $target.data('index'), true );
				updateDots( $target.data('index') );
			} );
		}

		function updateDots( index ) {
			let $dots = $('.js-scrollify-dots');

			$dots.children('.is-active').removeClass('is-active');
			$dots.children().eq( index ).addClass('is-active');
		}

		function destroyDots() {
			let $dots = $('.js-scrollify-dots');

			if ( $dots.length ) {
				$dots.remove();
			}
		}

		$(window).on( 'resize', debounce( update, 150 ) );
		update();

		return {
			isInitialised: () => {
				// Needs to be function to dynamically update the value when the local var changes
				return isInitialised;
			},
			update
		};

	} )();

	window.scrollifyController = scrollifyController;

} )( jQuery, window, document );
